import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLiveNoSignal: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLiveNoSignal"><Path d="M15.8891 8.11084C18.037 10.2587 18.037 13.7411 15.8891 15.889M8.11091 15.889C5.96303 13.7411 5.96303 10.2587 8.11091 8.11084" stroke="currentColor" strokeLinecap="square"/><Path d="M10.3359 13.6641L13.6644 10.3356" stroke="currentColor" strokeLinecap="square"/><Path d="M10.3359 10.3359L13.6644 13.6644" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconLiveNoSignal;
